import { render, staticRenderFns } from "./SystemAdminManagementAdminCreate.vue?vue&type=template&id=792f0d09"
import script from "./SystemAdminManagementAdminCreate.vue?vue&type=script&lang=js"
export * from "./SystemAdminManagementAdminCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports